export const socials = [
  {
    icon: 'fa-brands fa-linkedin',
    path: 'https://www.linkedin.com/company/starsoft-igames',
  },
];
